import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AppConfiguration, AppConfig } from "src/configuration";
import { BaseService } from "./base.service";
@Injectable({
  providedIn: "root",
})
export class XepLoaiGiangVienService extends BaseService {
  constructor(
    @Inject(AppConfig) private readonly appConfig: AppConfiguration,
    private http: HttpClient
  ) {
    super();
  }

  getAll(token): Observable<any> {
    return this.http
      .get<any>(this.appConfig.SurveyURL + "/xep-loai-giang-vien/get-all", {
        headers: new HttpHeaders()
          .set("Authorization", `Bearer ${token}`)
          .set("Access_code", this.access_code),
      })
      .pipe(
        map((z) => {
          return z;
        })
      );
  }

  insert(token, m): Observable<any> {
    return this.http
      .post<any>(this.appConfig.SurveyURL + "/xep-loai-giang-vien/insert", m, {
        headers: new HttpHeaders()
          .set("Authorization", `Bearer ${token}`)
          .set("Access_code", this.access_code),
      })
      .pipe(
        map((z) => {
          return z;
        })
      );
  }

  update(token, m): Observable<any> {
    return this.http
      .put<any>(this.appConfig.SurveyURL + "/xep-loai-giang-vien/update", m, {
        headers: new HttpHeaders()
          .set("Authorization", `Bearer ${token}`)
          .set("Access_code", this.access_code),
      })
      .pipe(
        map((z) => {
          return z;
        })
      );
  }

  delete(token, ID_xep_loai_giang_vien): Observable<any> {
    return this.http
      .delete<any>(this.appConfig.SurveyURL + "/xep-loai-giang-vien/delete?ID_xep_loai_giang_vien="+ID_xep_loai_giang_vien, {
        headers: new HttpHeaders()
          .set("Authorization", `Bearer ${token}`)
          .set("Access_code", this.access_code),
      })
      .pipe(
        map((z) => {
          return z;
        })
      );
  }
}
